// extracted by mini-css-extract-plugin
export default {"root":"Popup__root___wNzWg"};